<div class="container">
  <div class="row" *ngFor="let data of columns">
    <div class="col box mr-2"></div>
    <div class="col box mr-2"></div>
    <div class="col box mr-2"></div>
    <div class="col box mr-2"></div>
    <div class="col box mr-2"></div>
  </div>
</div>